import { COLLECTION_NAME } from ".";
import { deleteDocument } from "db/mutations";

export const deleteStory = async (storyId) => {
  try {
    await deleteDocument(COLLECTION_NAME, storyId);
    return { success: true };
  } catch (error) {
    console.error("Error deleting story:", error);
    return { success: false, error: error.message };
  }
};
